import SearchViewPreview from './SearchViewPreview';

export default SearchViewPreview;
